import { LazyLoad } from '@petconsole/pure-fe-mui';

const VanRepairAdmin = LazyLoad(() => import('./VanRepairAdmin'));

export { VanRepairAdmin };
